export enum LogLevel {
  Error,
  Warning,
  Info,
  Http,
  Verbose,
  Debug,
}
